module.exports = __webpack_public_path__ + "static/media/cal-patch.b6cf496a.jpg";